import io from "socket.io-client";
import SocketEvent from "./SocketEvent.js";
const EventEmitter = require('events').EventEmitter

//注意：
//socket通道与video标签是一对一的关系
//当用户切换视频时，video标签改变，也就是pattern改变了
//此时需新增一个socket通道
//判断用户是否切换视频，只需要判断当前用户操作的videoId是否变了

class SocketService extends EventEmitter{

  constructor() {
    super();
    this.socketIo = null;
    this.connectStatus = 0;
    this.videoId = "";
  };
  
  initSocket(wsServerUrl, socketIoPath){

    const socketIo = io(wsServerUrl, {
      path: socketIoPath,
      transports: ['websocket']
    });
    this.socketIo = socketIo;
    
    socketIo.on("connect", socket => {
      console.log('Socket connected');
      this.connectStatus = 1;
      //监听remote用户已下载好pattern数据
      socketIo.on(SocketEvent.GetReadyPatternDTO, (data) => {
        this.emit(SocketEvent.GetReadyPatternDTO, data);
      });
      //监听remote用户扫码成功，返回玩具数组
      // socketIo.on(SocketEvent.ScanCodeSuccessDTO, (data) => {
      //   this.emit(SocketEvent.ScanCodeSuccessDTO, data);
      // });
      socketIo.on(SocketEvent.ExitPatternSyncDTO, (data) => {
        this.emit(SocketEvent.ExitPatternSyncDTO, data);
      });
      //监听remote用户扫码确认连接玩具
      socketIo.on(SocketEvent.RemoteSyncStatusDTO, (data) => {
        this.emit(SocketEvent.RemoteSyncStatusDTO, data);
      });
      socketIo.on(SocketEvent.GetVideoProgressDTO, (data) => {
        this.emit(SocketEvent.GetVideoProgressDTO, data);
      })
      socketIo.on(SocketEvent.ErrorSyncPatternDTO, (data) => {
        this.emit(SocketEvent.ErrorSyncPatternDTO, data);
      })
      socketIo.on(SocketEvent.SuccessDownloadPatternDTO, (data) => {
        this.emit(SocketEvent.SuccessDownloadPatternDTO, data);
      })
      socketIo.on(SocketEvent.DisconnectPatternSyncDTO, (data) => {
        this.emit(SocketEvent.DisconnectPatternSyncDTO, data);
      })
      socketIo.on(SocketEvent.SyncPatternStatusChangeDTO, (data) => {
        this.emit(SocketEvent.SyncPatternStatusChangeDTO, data);
      })
      socketIo.on(SocketEvent.VideoPreviewStatusDTO, (data) => {
        this.emit(SocketEvent.VideoPreviewStatusDTO, data);
      })
    });

    socketIo.on('disconnect', () => {
      console.log('Socket disconnnect');
      this.emit(SocketEvent.SocketDisconnectDTO, {});
    });
  }

  close(){
    this.socketIo.close();
  }
  
  open(){
    this.socketIo.open();
  }

  socketEmitMsg (type, data) {
    // if(this.socketIo && this.connectStatus === 1) {
      if(this.socketIo && (this.connectStatus === 1 || this.connectStatus === 0)) {
      this.socketIo.emit(type, data);
    }
  }

  //type:0表示仅查询，1表示查询后进行后续业务操作
  getSyncStatus(type=0){
    if(this.socketIo && (this.connectStatus === 1 || this.connectStatus === 0)) {
      this.socketIo.emit(SocketEvent.GetSyncStatusDTO, (data)=>{
        if(type === 1){
          let obj = {...data, type:1}
          this.emit(SocketEvent.GetSyncStatusDTO, obj);
        }else{
          this.emit(SocketEvent.GetSyncStatusDTO, data);
        }
      });
    }
  }

  getListenerCount(eventName) {
    return this.listenerCount(eventName)
  }

  //普通消息事件(非socket)
  setPlaySpeed(speed){
    this.emit(SocketEvent.SetPlaySpeedDTO, {speed: speed});
  }
}

export { SocketService };